import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import authConfig from '../../authConfig';
import { useSelector, useDispatch } from "react-redux";
/**
 * MemberFutureMeetingsSelector
 * Fetches and allows a member to select from their future meetings.
 *
 * @param {Object} props
 * @param {Function} props.onSelect - Callback when a meeting is selected
 */
const MemberAttendanceTypeSelector = ({ onSelect, required = false }) => {
    const [attendanceTypes, setAttendanceTypes] = useState([]);
    const [selectedType, setSelectedType] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAttendanceTypes = async () => {
            setLoading(true);
            try {
                const response = await fetch(authConfig.api.urls.getMeetingAttandanceTypes);
                const data = await response.json();
                // Map API data to expected format
                const types = [];
                for (var o of data) {
                    if (o.isApology) {
                        types.push(o)
                    }
                }
                setAttendanceTypes(types);

            } catch (error) {
                setAttendanceTypes([]);
            }
            setLoading(false);
        };
        fetchAttendanceTypes();
    }, []);

    const handleChange = (e) => {
        setSelectedType(e.target.value);
        if (onSelect) {
            onSelect(e.target.value);
        }
    };

    return (
        <>
            {loading ? (
                <Spinner animation="border" size="sm" />
            ) : (
                <Form.Select
                        id="attendancetype-selectlist"
                        value={selectedType.name}
                    onChange={handleChange}
                    required={required}
                >
                    <option value="">-- Select --</option>
                    {attendanceTypes.map(attendancetype => (
                        <option key={attendancetype.id} value={attendancetype.name}>
                            {attendancetype.name}
                        </option>
                    ))}
                </Form.Select>
            )}
        </>
    );
};

MemberAttendanceTypeSelector.propTypes = {
    onSelect: PropTypes.func,
    required: PropTypes.bool
};

export default MemberAttendanceTypeSelector;